<template>
  <div class="appointment__wrapper">
    <div class="appointment__prefix">
      <div class="appointment__date">
        <span class="bold">{{ appointment.dateTimeInterval }}</span>
      </div>
      <template v-if="layout !== 'career'">
        <div class="appointment__language" v-if="appointment.language" v-bind:class="'-language-' + appointment.language">
          <span class="language__flag" v-bind:class="'-' + appointment.language"></span>
          <span v-if="appointment.language === 'de'" class="language__name meta">{{ $t('languages.germany') }}</span>
          <span v-else-if="appointment.language === 'en'" class="language__name meta">{{ $t('languages.english') }}</span>
        </div>
      </template>
    </div>
    <div class="appointment__info">
      <div class="appointment__title">
        <span class="heading delta">{{appointment.name}}</span>
      </div>
      <div class="appointment__text" v-html="appointment.description">
      </div>
    </div>
    <div class="appointment__suffix">
      <div v-if="layout !== 'career'" class="suffix__area suffix__area--top">
        <span class="appointment__badges appointment__badges--beta">{{appointment.industry.name}}</span>
        <span class="appointment__badges">{{appointment.category.name}}</span>
      </div>
      <template v-if="layout !== 'career'">
        <div class="suffix__area suffix__area--bottom">
          <span v-if="appointment.isOnline" class="appointment__badges appointment__badges--white">{{ $t('types.online') }}</span>
          <span v-else class="appointment__badges appointment__badges--white">{{ $t('types.site') }}</span>
        </div>
      </template>
      <template v-else>
        <div class="suffix__area suffix__area--bottom">
          <span class="appointment__badges appointment__badges--white">{{appointment.location.name}}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: ['appointment', 'layout']
}
</script>
